import { format, isToday, parseISO } from "date-fns"
import i18n from "@/i18n"
import { getDateFnsLocale } from "@/lib/date-fns-locale"

export const formatDateStringWithTranslate = (date: string, dateFormat: string, locale: string): string => {
  return format(parseISO(date), dateFormat, { locale: getDateFnsLocale(locale) })
}

export const formatDateForChatConversation = (
  date: string,
  locale: string,
  isMessageGroupDate: boolean = false,
): string => {
  const { t } = i18n
  const dateObj = new Date(date)
  const dateIsToday = isToday(dateObj)
  const preposition = dateIsToday ? t("chat.date.at") : t("chat.date.on")
  let stringDate = ""
  if (!dateIsToday) {
    stringDate = `${formatDateStringWithTranslate(date, "cccc do MMMM", locale)}`
    if (!isMessageGroupDate) {
      stringDate += ` ${t("chat.date.at")}`
    }
  }

  if (isMessageGroupDate) {
    return stringDate
  }
  return `${preposition} ${stringDate} ${formatDateStringWithTranslate(date, "HH:mm", locale)}`
}
